import { useState } from "react";
import {
  FaEnvelope,
  FaLock,
  FaEye,
  FaEyeSlash,
  FaIndustry
} from "react-icons/fa";
import "./Login.css";

import { login } from "../../api/authApi";
import { useNavigate } from "react-router-dom";

const Login = () => {

  const navigate = useNavigate();

  const [showPassword, setShowPassword] =
    useState(false);

  const [loading, setLoading] =
    useState(false);

  const [form, setForm] =
    useState({
      email: "",
      password: ""
    });

  const submit = async (e) => {

    e.preventDefault();

    try {

      setLoading(true);

      const res =
        await login(form);

      localStorage.setItem(
        "token",
        res.data.token
      );

      navigate("/dashboard");

    } catch (error) {

      alert(
        error?.response?.data?.message ||
        "Login Failed"
      );

    } finally {

      setLoading(false);

    }

  };

  return (

    <div
      className="login-wrapper"
    >

      <div
        className="login-card"
      >

        <div
          className="text-center mb-4"
        >

          <div
            className="logo-circle"
          >
            <FaIndustry />
          </div>

          <h2 className="mt-3 fw-bold">
            PaperStock ERP
          </h2>

          <p className="text-muted">
            Inventory & Production Management
          </p>

        </div>

        <form onSubmit={submit}>

          <div className="input-group mb-3">

            <span className="input-group-text">
              <FaEnvelope />
            </span>

            <input
              type="email"
              className="form-control"
              placeholder="Email Address"
              value={form.email}
              onChange={(e) =>
                setForm({
                  ...form,
                  email: e.target.value
                })
              }
              required
            />

          </div>

          <div className="input-group mb-4">

            <span className="input-group-text">
              <FaLock />
            </span>

            <input
              type={
                showPassword
                  ? "text"
                  : "password"
              }
              className="form-control"
              placeholder="Password"
              value={form.password}
              onChange={(e) =>
                setForm({
                  ...form,
                  password: e.target.value
                })
              }
              required
            />

            <button
              type="button"
              className="btn btn-light border"
              onClick={() =>
                setShowPassword(
                  !showPassword
                )
              }
            >
              {
                showPassword
                  ? <FaEyeSlash />
                  : <FaEye />
              }
            </button>

          </div>

          <button
            className="btn btn-success w-100 py-2 fw-bold"
            disabled={loading}
          >

            {
              loading
                ? "Signing In..."
                : "Login"
            }

          </button>

        </form>

        <div
          className="text-center mt-4"
        >

          <small className="text-muted">
            © {new Date().getFullYear()}
            {" "}
            PaperStock ERP
          </small>

        </div>

      </div>

    </div>

  );

};

export default Login;